import React, { useEffect, useState } from "react";
import useBenefitsStore from "../state";

import { Hero } from "../components/Hero";
import { Banner } from "../components/Banner";
import { Filter } from "../components/Filter";
import { BenefitsContainer } from "../components/BenefitsContainer";
import axios from "axios";
import { ModalBenefitDetail } from "../components/ModalBenefitDetail";

const Benefits = ({ video }) => {
    const setData = useBenefitsStore((store) => store.setData);
    const [selectedBenefit, setSelectedBenefit] = useState(null);
    const [newURL, setNewURL] = useState(null);

    useEffect(() => {
        fetchBenefits();
    }, []);

    const fetchBenefits = async () => {
        await axios
            .get("/api/website/benefits/")
            .then((response) => {
                setData(response);
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const handleOpenModal = (benefit) => {
        setSelectedBenefit(benefit);
    };
    const handleCloseModal = () => {
        setSelectedBenefit(null);
    };

    useEffect(() => {
        const videoSrc = video;
        const replaceWatch = videoSrc.replace("watch?v=", "embed/");
        const nuevoEnlace =  replaceWatch + "?autoplay=0";
        setNewURL(nuevoEnlace)
    }, [video]);

    return (
        <div className='benefits'>
            <Hero />
            {/* <Banner /> */}

            {
                video !== "None" &&
                <section className="video">
                    <div className="bg-container">
                        <div className="bg-top"></div>
                        <div className="bg-bottom"></div>
                    </div>
                    <div className="main-container video-container">
                            <iframe src={newURL} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                    </div>
                </section>
            }

            <div className='main-container'>
                <div className='benefits-wrapper'>
                    <Filter />

                    <BenefitsContainer handleOpenModal={handleOpenModal} />
                </div>
            </div>
            <ModalBenefitDetail
                benefit={selectedBenefit}
                onCloseModal={() => handleCloseModal()}
            />
        </div>
    );
};

export default Benefits;
